import styled from 'styled-components';
import { LoadImage, Title } from 'components';
import { px2rem } from 'src/util';

export const BlockWrapper = styled.section`
  display: flex;

  @media screen and (min-width: 998px) {
    justify-content: center;
    padding: ${px2rem(230)} ${px2rem(40)};
  }

  @media screen and (max-width: 997px) {
    align-items: center;
    flex-direction: column;
    padding: 40px 0 120px;
  }
`;

export const TextWrapper = styled.div`
  ${Title} {
    margin: ${px2rem(24)} 0;
  }

  @media screen and (min-width: 998px) {
    margin-right: ${px2rem(120)};
    max-width: ${px2rem(410)};
  }

  @media screen and (max-width: 997px) {
    margin-bottom: 80px;
    padding: 0 20px;
  }
`;

export const StyledImage = styled(LoadImage)`
  @media screen and (max-width: 997px) {
    width: 100%;
  }
`;

export const Tooltip = styled.img`
  @media screen and (min-width: 998px) {
    position: absolute;
    transition: opacity 0.3s 0.3s;
  }

  @media screen and (max-width: 997px) {
    display: none;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media screen and (min-width: 998px) {
    width: ${px2rem(700)};
  }

  @media screen and (max-width: 997px) {
    width: 100%;
  }
`;

export const ScrollableWrapper = styled.div`
  display: flex;
  width: 100%;

  @media screen and (min-width: 998px) {
    margin-bottom: ${px2rem(46)};
  }

  @media screen and (max-width: 997px) {
    margin-bottom: 34px;
    overflow-x: auto;
    padding-bottom: 10px;
  }
`;

export const TabsList = styled.ul`
  border-bottom: 1px solid #ced4da;
  display: flex;
  justify-content: space-between;

  @media screen and (min-width: 998px) {
    padding: 0 ${px2rem(40)};
    width: 100%;
  }

  @media screen and (max-width: 997px) {
    flex-shrink: 0;
    min-width: 100%;
    padding: 0 20px;
  }
`;

export const TabListItem = styled.li`
  @media screen and (min-width: 998px) {
    &:not(:last-of-type) {
      margin-right: ${px2rem(40)};
    }
  }

  @media screen and (max-width: 997px) {
    flex-shrink: 0;

    &:not(:last-of-type) {
      margin-right: 48px;
    }
  }
`;

export const TabButton = styled.button<any>`
  font-family: 'Univia Pro', 'Arial', 'sans-serif';
  position: relative;

  &::after {
    background-color: #005370;
    bottom: -${px2rem(4)};
    content: '';
    display: block;
    height: ${px2rem(8)};
    left: 0;
    position: absolute;
    transition: width 0.3s;
    width: 0;
  }

  ${({ active }) =>
    active &&
    `
      color: #005370;

      &::after {
        width: 100%;
      }
    `}

  @media screen and (min-width: 998px) {
    padding: ${px2rem(25)} ${px2rem(10)};
  }

  @media screen and (max-width: 997px) {
    padding: 10px 5px;
  }
`;

export const TabContent = styled.div<any>`
  align-self: center;
  position: relative;
  transition: opacity 0.3s;

  img:first-of-type {
    filter: drop-shadow(
      ${px2rem(20)} ${px2rem(14)} ${px2rem(64)} rgba(54, 64, 152, 0.13)
    );
  }

  ${({ isTransitioning }) =>
    isTransitioning &&
    `
      opacity: 0;

      ${Tooltip} {
        opacity: 0;
      }
    `}

  @media screen and (min-width: 998px) {
    height: ${px2rem(327)};

    img:nth-of-type(2) {
      filter: drop-shadow(0 ${px2rem(4)} ${px2rem(44)} rgba(30, 81, 110, 0.3));
    }
  }

  @media screen and (max-width: 997px) {
    min-height: ${(170 / 375) * 100}vw;
    padding: 0 20px;
  }
`;

export const TabsMarkersList = styled.ul`
  align-self: center;
  align-items: center;
  display: flex;
  justify-content: center;
  margin-top: ${px2rem(40)};
`;

const TabMarkerImage = styled.img`
  transition: opacity 0.3s;

  @media screen and (min-width: 998px) {
    width: ${px2rem(85)};
  }

  @media screen and (max-width: 997px) {
    width: 72px;
  }
`;

export const TabMarkerActive = styled(TabMarkerImage)`
  height: 100%;
  left: 0;
  opacity: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 1;
`;

export const TabMarkerInactive = styled(TabMarkerImage)``;

export const TabsMarkersListItem = styled.li`
  &:not(:last-of-type) {
    margin-right: ${px2rem(8)};
  }
`;

export const TabMarker = styled.button<any>`
  color: transparent;
  display: block;
  font-size: 0;
  line-height: 0;
  position: relative;

  ${({ active }) =>
    active &&
    `
      ${TabMarkerActive} {
        opacity: 1;
      }
    `}
`;
